import * as React from 'react'
import {Card, Tooltip} from 'antd'
import styles from './styles.module.scss'
import {BarDropdown} from '../bar-dropdown/BarDropdown'
import {UserSupportIcon} from '../../icons/UserSupportIcon'
import {UserGuideIcon} from '../../icons/UserGuideIcon'
import {TrainingIcon} from '../../icons/TrainingIcon'
import {GlossaryIcon} from '../../icons/GlossaryIcon'
import {ProductRoadMapIcon} from '../../icons/ProductRoadMapIcon'
import {Routes} from '../../routing/routes'
import {FaqIcon} from '../../icons/FaqIcon'

const Icon = () => {
  return (
    <Tooltip overlayClassName='nav-bar-app' placement='bottom' title='Support'>
      <UserSupportIcon className={styles.userSupportIcon} />
    </Tooltip>
  )
}

export const Panel = () => {
  return (
    <Card
      className={styles.card}
      title={<h3 className={styles.dropDownTitle}>Support</h3>}
    >
      <ul>
        <li>
          <a href={Routes.UserGuidePDF}>
            <span className={styles.supportLinkWrapper}>
              <UserGuideIcon className={styles.supportIcon} />
              <div>
                <div className={styles.title}>Quick Start Guide</div>
                <div className={styles.description}>
                  New users, get introduced to our most used modules and get
                  up-to-speed with functionality and fields.
                </div>
              </div>
            </span>
          </a>
        </li>
        <li>
          <a href={Routes.FaqPDF}>
            <span className={styles.supportLinkWrapper}>
              <FaqIcon className={styles.supportIcon} />
              <div>
                <div className={styles.title}>Frequently Asked Questions</div>
                <div className={styles.description}>
                  Read answers to our most frequently asked questions from our
                  customers across all aspects of Vantage.
                </div>
              </div>
            </span>
          </a>
        </li>
        <li>
          <a href={Routes.Training}>
            <span className={styles.supportLinkWrapper}>
              <TrainingIcon className={styles.supportIcon} />
              <div>
                <div className={styles.title}>Training</div>
                <div className={styles.description}>
                  Discover materials in PDF or video to support users when
                  running analysis of interest.
                </div>
              </div>
            </span>
          </a>
        </li>
        <li>
          <a href={Routes.Glossary}>
            <span className={styles.supportLinkWrapper}>
              <GlossaryIcon className={styles.supportIcon} />
              <div>
                <div className={styles.title}>Glossary</div>
                <div className={styles.description}>
                  Search and access all relevant fields and terms used within{' '}
                  <br />
                  Vantage.
                </div>
              </div>
            </span>
          </a>
        </li>
        <li>
          <a href={Routes.ProductRoadMapPDF}>
            <span className={styles.supportLinkWrapper}>
              <ProductRoadMapIcon className={styles.supportIcon} />
              <div>
                <div className={styles.title}>Product Roadmap</div>
                <div className={styles.description}>
                  Learn about the new data and features we are working on to add
                  to Vantage
                </div>
              </div>
            </span>
          </a>
        </li>
      </ul>
    </Card>
  )
}

export const UserSupportPanel = () => {
  return (
    <BarDropdown dropDownClassName={styles.dropDown} icon={<Icon />} dataTestId={'user-support-panel-dropdown'}>
      <Panel />
    </BarDropdown>
  )
}
